(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("openBadgesSettings", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/openBadges/openBadgesSettingsView.html",
            controller: ["tenantOpenBadgesResource", "messageService", "cropPictureService", "REG_EXP", "$rootScope", OpenBadgesSettingsCtrl],
            controllerAs: "vm"
        };
        function OpenBadgesSettingsCtrl(tenantOpenBadgesResource, messageService, cropPictureService, REG_EXP, $rootScope) {
            var vm = this;
            vm.jcropData = {};
            vm.model = {};
            vm.saving = false;
            vm.loading = true;
            vm.hasPicture = false;
            vm.form = {};
            vm.emailPattern = REG_EXP.email;
            tenantOpenBadgesResource.get(function (model) {
                vm.model = model;
                vm.originalOpenBadgesEnabled = vm.model.enabled;
                vm.loading = false;
            });
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    tenantOpenBadgesResource.save(vm.model, function (data) {
                        //remove the temp folders where image was saved
                        if (vm.model.issuerDetails.cropData && vm.model.issuerDetails.cropData.tempFolderGuid)
                            cropPictureService.removeTempFolder(vm.model.issuerDetails.cropData.tempFolderGuid);
                        vm.model = data;
                        messageService.success("common.changesSaved");
                        vm.saving = false;
                        $rootScope.$broadcast("reloadTenantSettings");
                        if (vm.model.enabled && !vm.originalOpenBadgesEnabled) {
                            tenantOpenBadgesResource.createMissingBadges(function () { }, function (error) {
                                messageService.error(error);
                            });
                        }
                        vm.originalOpenBadgesEnabled = vm.model.enabled;
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else
                    vm.showErrors = true;
            };
            vm.changeImage = function () {
                var modalInstance = cropPictureService.changePicture(vm.model.issuerDetails.cropData, {
                    //image restrictions
                    jcrop: {
                        minSize: [24, 24],
                        maxSize: [1000, 0],
                        maxHeight: 299.9,
                        boxWidth: 300,
                        boxHeight: 300,
                        aspectRatio: 0
                    }
                });
                modalInstance.result.then(function (pictureData) {
                    //Crop the image so its shown properly on the page
                    if (pictureData.cropData && pictureData.cropData.fileUrl) {
                        vm.processingImage = true;
                        vm.model.issuerDetails.cropData = pictureData.cropData;
                        tenantOpenBadgesResource.cropIssuerImage(pictureData.cropData, function (data) {
                            //Set the crop info for the badge to be saved later
                            vm.model.issuerDetails.cropDataJson = data.cropDataJson;
                            vm.model.issuerDetails.cropData = JSON.parse(data.cropDataJson);
                            vm.model.issuerDetails.imageUrl = data.fileUrl;
                            vm.processingImage = false;
                        }, function (error) {
                            messageService.error(error);
                            vm.saving = false;
                            vm.processingImage = false;
                        });
                    }
                }).catch(angular.noop);
            };
        }
    });
})();
